import { render, staticRenderFns } from "./ContactsSectionInfoItem.vue?vue&type=template&id=2403a58e&scoped=true&"
import script from "./ContactsSectionInfoItem.vue?vue&type=script&lang=js&"
export * from "./ContactsSectionInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSectionInfoItem.vue?vue&type=style&index=0&id=2403a58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2403a58e",
  null
  
)

export default component.exports